import "./Policy.css";

function Policy() {
  return (
    <div className="container policy">
      <h1 className="text-center">Policy</h1>
      <div className="d-block">
        <h4>1. Privacy Policy</h4>
        <p>
          <li>
            <span>1.1</span>
            <span>
              Standout Fresh Produce respects your privacy and is committed to
              protecting your personal information.
            </span>
          </li>
          <li>
            <span>1.2</span>
            <span>
              Information collected (such as name, contact details, address, and
              payment details) is used only for order processing, delivery, and
              communication.
            </span>
          </li>
          <li>
            <span>1.3</span>
            <span>
              We do not sell, rent, or share customer information with third
              parties, except as required to complete deliveries or comply with
              the law.
            </span>
          </li>
          <li>
            <span>1.4</span>
            <span>
              Payment information is processed securely through trusted payment
              gateways; we do not store card details.
            </span>
          </li>
          <li>
            <span>1.5</span>
            <span>
              By using our website, you consent to the collection and use of
              your data as outlined in this policy.
            </span>
          </li>
        </p>
      </div>
      <div className="d-block">
        <h4>2. Shipping/Delivery Policy</h4>
        <p>
          <li>
            <span>2.1</span>
            <span>
              Deliveries are available within designated service areas
              (specified on the website).
            </span>
          </li>
          <li>
            <span>2.2</span>
            <span>
              Orders are delivered within <b>24-72 hours</b> of confirmation,
              depending on availability and location.
            </span>
          </li>
          <li>
            <span>2.3</span>
            <span>
              Delivery fees may apply and will be displayed at checkout.
            </span>
          </li>
          <li>
            <span>2.4</span>
            <span>
              Customers must ensure someone is available to receive the order at
              the specified address.
            </span>
          </li>
          <li>
            <span>2.5</span>
            <span>
              Standout Fresh Produce is not responsible for delays caused by
              factors beyond our control (e.g., strikes, severe weather,
              transport disruptions).
            </span>
          </li>
        </p>
      </div>
      <div className="d-block">
        <h4>3. Refund & Return Policy</h4>
        <p>
          <li>
            <span>3.1</span>
            <span>
              Due to the perishable nature of fresh produce, refunds and returns
              are limited.
            </span>
          </li>
          <li>
            <span>3.2</span>
            <span>
              Customers must inspect their order upon delivery. Any issues
              (damaged or spoiled produce) must be reported within{" "}
              <b>24 hours</b> with supporting photos.
            </span>
          </li>
          <li>
            <span>3.3</span>
            <span>
              If approved, refunds will be issued, or replacement items will be
              arranged for the next delivery.
            </span>
          </li>
          <li>
            <span>3.4</span>
            <span>
              Refunds are processed within <b>7 working days</b> to the original
              payment method.
            </span>
          </li>
          <li>
            <span>3.5</span>
            <span>
              Standout Fresh Produce reserves the right to decline refund
              requests that fall outside these conditions.
            </span>
          </li>
        </p>
      </div>
    </div>
  );
}

export default Policy;
